import { classNames } from '@shopify/css-utilities'
import { motion } from 'framer-motion'
import { useContext } from 'react'
import styles from '../../assets/scss/components/header/burger-icon.module.scss'
import { HeaderContext } from './header-provider.client'

export const BurgerIcon: React.FC<{
  isInitiallyOpaque: boolean
  variant?: string
}> = ({ isInitiallyOpaque, variant }) => {
  const { burgerIconOpacity, isMainNavigationOpen, notificationBarBoundingClientRect, setIsMainNavigationOpen } =
    useContext(HeaderContext)

  return (
    <motion.div
      initial={{ opacity: isInitiallyOpaque ? 0 : 1 }}
      animate={{ opacity: 1 }}
      className={classNames(styles.container, variant && !isMainNavigationOpen && styles[variant])}
      id="burger-icon"
      style={{
        opacity: burgerIconOpacity,
        paddingTop: notificationBarBoundingClientRect?.height ? notificationBarBoundingClientRect?.height + 10 : 17,
      }}>
      <div className="section px">
        <div
          className={classNames(styles.burgerIcon, isMainNavigationOpen && styles.open)}
          onClick={() => setIsMainNavigationOpen(!isMainNavigationOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </motion.div>
  )
}
